import { FC, useMemo } from 'react';
import { useUserContext } from '../contexts/user_context';

import './user_info.css';

import avatar from '../assets/avatar.jpg';
import { useProgressionContext } from '../contexts/progression_context';

export function get_format_number(value: number, symbol = ' '): string {
    const fixed_value = isNaN(value) ? 0 : Math.round(value * 100) / 100;
    return fixed_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
}

const CIRCLE_RADIUS = 20;
const CIRCLE_STROKE_WIDTH = 3;

export const UserInfoComponent: FC = () => {
    const { username, access_token, xp, rank, balance } = useUserContext();
    const { tiers } = useProgressionContext();

    const get_circle_params = (progress: number) => {
        const normalized_progress = Math.min(Math.max(progress, 0), 100);
        const dash_array = 2 * Math.PI * CIRCLE_RADIUS;
        const dash_offset = dash_array - (dash_array * normalized_progress) / 100;
        return { dash_array, dash_offset };
    };

    const { circle_dash_array, circle_dash_offset }: Record<string, number> = useMemo(() => {
        let _xp = xp;
        for (const tier of tiers) {
            if (tier.max_xp >= _xp) break;
            _xp -= tier.max_xp;
        }
        const percent = (_xp / (tiers[rank]?.max_xp || tiers[tiers.length - 1]?.max_xp)) * 100;
        const normalized_percent = !isNaN(percent) ? percent : 0
        const circle_dash_array = get_circle_params(normalized_percent).dash_array;
        const circle_dash_offset = get_circle_params(normalized_percent).dash_offset;
        return { percent, circle_dash_array, circle_dash_offset };
    }, [xp, rank, tiers]);

    return (
        <>
            {access_token ? (
                <div className='user-info'>
                    <div className='info-container'>
                        <div className='user-balance'>
                            {'$ '}
                            {get_format_number(balance, ' ')}
                        </div>
                        <div className='user-name'>
                            <span>{username}</span>
                            <div className='user-points'>{xp} Points</div>
                            <div className='user-image'>
                                <span className='rank'>{`lvl ${rank + 1}`}</span>
                                <img alt='' src={avatar} />
                                <svg
                                    width={CIRCLE_RADIUS * 2}
                                    height={CIRCLE_RADIUS * 2}
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <circle
                                        cx={CIRCLE_RADIUS}
                                        cy={CIRCLE_RADIUS}
                                        r={CIRCLE_RADIUS - CIRCLE_STROKE_WIDTH / 2}
                                        fill='transparent'
                                        stroke='#2B2B2B'
                                        strokeWidth={CIRCLE_STROKE_WIDTH}
                                    />
                                    <circle
                                        cx={CIRCLE_RADIUS}
                                        cy={CIRCLE_RADIUS}
                                        r={CIRCLE_RADIUS - CIRCLE_STROKE_WIDTH / 2}
                                        fill='transparent'
                                        stroke='var(--color-yellow)'
                                        strokeWidth={CIRCLE_STROKE_WIDTH}
                                        strokeDasharray={circle_dash_array}
                                        strokeDashoffset={circle_dash_offset}
                                        transform={`rotate(-90 ${CIRCLE_RADIUS} ${CIRCLE_RADIUS})`}
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='user-info user-info-empty' />
            )}
        </>
    );
};
